// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  scroll-behavior: smooth;
  padding: 10px;
  position: relative;
}

ion-icon.top-icon-cloud {
  position: absolute;
  top: -50px;
  left: -100px;
  font-size: 20rem !important;
  opacity: 0.4;
  filter: blur(8.2px);
}

ion-icon.bottom-icon-cloud {
  position: absolute;
  bottom: -50px;
  right: -100px;
  font-size: 20rem !important;
  opacity: 0.4;
  filter: blur(8.2px);
}

.title-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  justify-content: center;
  width: 100%;
  padding: 10px;
}

.title {
  font-size: 1.5em;
  margin: 0;
  padding: 0;
  text-align: center;
}

.subtitle {
  margin: 0;
  padding: 0;
  text-align: center;
  font-size: 1rem;
}

form {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 10px;
}

ion-card {
  width: 100%;
  max-width: 500px;
}

.words-suggestion-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  padding: 5px;
  max-width: 500px;
}

.red-alert,
.warning-alert {
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  border-radius: 8px;
}

.red-alert {
  background: rgba(223, 64, 64, 0.7882352941);
}

.warning-alert {
  background: rgba(223, 207, 64, 0.7882352941);
}

.red-alert-text {
  color: white;
}

.warning-alert-text {
  color: #000000;
}

.btn-custom-shape {
  --border-radius: 8px !important;
  font-size: 1rem;
  height: 48px;
  cursor: pointer;
}

.align-loader-custom {
  margin-top: 15px;
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  margin: 0 auto;
}

@media screen and (min-width: 768px) {
  .background {
    width: 100vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/word-cloud/word-cloud.page.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,2BAAA;EACA,YAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,aAAA;EACA,aAAA;EACA,2BAAA;EACA,YAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;AACJ;;AAEA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AACJ;;AAEA;EACI,SAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;AACJ;;AAEA;EACI,WAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AACJ;;AAEA;;EAEI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACJ;;AACA;EACI,2CAAA;AAEJ;;AAAA;EACI,4CAAA;AAGJ;;AADA;EACI,YAAA;AAIJ;;AAFA;EACI,cAAA;AAKJ;;AAFA;EACI,+BAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AAKJ;;AAFA;EACI,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;AAKJ;;AAFA;EACI;IACI,YAAA;EAKN;AACF","sourcesContent":[".background {\n    display: flex; \n    align-items: center; \n    justify-content: center; \n    flex-direction: column; \n    height: 100%;\n    overflow: hidden;\n    scroll-behavior: smooth;\n    padding: 10px;\n    position: relative;\n}\n\nion-icon.top-icon-cloud {\n    position: absolute;\n    top: -50px;\n    left: -100px;\n    font-size: 20rem !important;\n    opacity: 0.4;\n    filter: blur(8.2px);\n}\n\nion-icon.bottom-icon-cloud {\n    position: absolute;\n    bottom: -50px;\n    right: -100px;\n    font-size: 20rem !important;\n    opacity: 0.4;\n    filter: blur(8.2px);\n}\n\n.title-box {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    justify-content: center;\n    width: 100%;\n    padding: 10px;\n}\n\n.title {\n    font-size: 1.5em;\n    margin: 0;\n    padding: 0;\n    text-align: center;\n}\n\n.subtitle {\n    margin: 0;\n    padding: 0;\n    text-align: center;\n    font-size: 1rem;\n}\n\nform {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 10px;\n    width: 100%;\n    padding: 10px;\n}\n\nion-card {\n    width: 100%;\n    max-width: 500px;\n}\n\n.words-suggestion-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 5px;\n    max-width: 500px;\n}\n\n.red-alert,\n.warning-alert {\n    width: 100%;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 10px;\n    border-radius: 8px;\n}\n.red-alert {\n    background: #df4040c9;\n}\n.warning-alert {\n    background: #dfcf40c9;\n}\n.red-alert-text {\n    color: white;\n}\n.warning-alert-text {\n    color: #000000;\n}\n\n.btn-custom-shape {\n    --border-radius: 8px !important;\n    font-size: 1rem;\n    height: 48px;\n    cursor: pointer;\n}\n\n.align-loader-custom {\n    margin-top: 15px;\n    width: 100%;\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n    margin: 0 auto;\n}\n\n@media screen and (min-width: 768px) {\n    .background {\n        width: 100vw;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
